import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({ name: 'CmgStarStrip' })
export default class CmgStarStrip extends Vue {
  @Prop({ type: Number, required: false, default: 0 })
  initialRating!: number;

  rating = 0;

  starImgs = {
    empty: this.$appStore.state.cms.images.icons.ratingStarDark.default,
    filled: this.$appStore.state.cms.images.icons.ratingStarFilled.default,
  };

  stars = [this.starImgs.empty, this.starImgs.empty, this.starImgs.empty, this.starImgs.empty, this.starImgs.empty];

  mounted() {
    // Load a default rating selection
    if (this.initialRating) {
      this.fillStarsUpTo(this.initialRating - 1);
      this.ratingSelected(this.initialRating);
    }
  }

  onMouseEnterRatingButton(idx: number): void {
    this.fillStarsUpTo(idx);
    this.$emit('rating-hovered', idx + 1);
  }

  onMouseLeaveRatingButton(idx: number): void {
    for (let i = idx; i >= this.rating; i--) {
      Vue.set(this.stars, i, this.starImgs.empty);
    }
    this.$emit('rating-unhovered');
  }

  onClickRate(idx: number): void {
    this.ratingSelected(idx);
    this.$emit('rating-selected', this.rating);
  }

  fillStarsUpTo(idx: number): void {
    for (let i = 0; i <= idx; i++) {
      Vue.set(this.stars, i, this.starImgs.filled);
    }
  }

  ratingSelected(idx: number): void {
    this.rating = idx + 1;
    for (let i = this.stars.length - 1; i >= this.rating; i--) {
      Vue.set(this.stars, i, this.starImgs.empty);
    }
  }
}
